import mixpanel from 'mixpanel-browser';
import { Helmet } from 'react-helmet-async';
import { forwardRef, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';
// @mui
import { Box, BoxProps, Stack, Typography } from '@mui/material';
// hooks
import useAuth from 'src/hooks/useAuth';
import useMerchant from 'src/hooks/useMerchant';
import usePage from 'src/hooks/usePage';
import useResponsive from 'src/hooks/useResponsive';
// components
import TopNavbar from 'src/layouts/dashboard/navbar/TopNavbar';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
  actions?: JSX.Element;
}
const Page = forwardRef<HTMLDivElement, Props>(({ children, title = '', meta, actions, ...other }, ref) => {
  const { user } = useAuth();
  const { merchant } = useMerchant();
  const { setPageTitle } = usePage();

  const location = useLocation();
  const mdUp = useResponsive('up', 'md');

  useEffect(() => {
    if (title) {
      setPageTitle(title);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  useEffect(() => {
    if (user?.email && merchant?.code) {
      mixpanel.track(`View: ${title}`, {
        title: `${title}`,
        url: window.location.href
      });
    }
  }, [title, user?.email, merchant?.code]);

  const isErrorPage = +location.pathname.replace(/^\D+/g, '')

  return <>
    <Helmet>
      <title>{`${title && `${title} |`} CarbonClick`}</title>
      {meta}
    </Helmet>

    {title && !isErrorPage &&
      <Stack spacing={2} sx={{ pb: 1.5 }}>
        <Stack gap={1} direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant='title1' sx={{ ml: 0, mr: 'auto' }}>{title}</Typography>
          {actions && <Box sx={{ mr: 0, ml: 'auto' }}>{actions}</Box>}
        </Stack>
        {!mdUp && <TopNavbar />}
      </Stack>
    }

    <Box ref={ref} {...other}>
      {children}
    </Box>
  </>
});

export default Page;
